import React from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTicketAlt } from "@fortawesome/free-solid-svg-icons";

export default ({ post }) => {
  const history = useHistory();

  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;
  const isSiteAdmin = user && user.roles && user.roles.includes("Site Admin");

  if (!isSiteAdmin) {
    return null;
  }

  const handleTicketClicked = () => {
    let postBody = post?.data?.text || post?.data?.content || post?.data?.topic || post?.data?.description || "";
    
    // Fallback if no specific text field is found
    if (!postBody && post?.data) {
      // Just stringify a few safe fields or state that content is in the post
      postBody = "See original post for details.";
    }

    const postUrl = window.location.href;
    const postDate = post?.created_at ? new Date(post.created_at).toLocaleString() : "Unknown Date";
    const teamInfo = post?.team?.name || post?.team_id || "Unknown Team";

    const fullBody = `Issue reported from a ReTeam post.\n\n` +
      `--- Post Details ---\n` +
      `Type: ${post?.type}\n` +
      `Author: ${post?.user?.full_name || "Unknown"}\n` +
      `Date: ${postDate}\n` +
      `Team: ${teamInfo}\n` +
      `Post Context Link: ${postUrl}\n\n` +
      `--- Content ---\n${postBody}`;

    history.push({
      pathname: "/support/ticket",
      state: { 
        postContent: fullBody, 
        postTitle: `Issue from post by ${post?.user?.full_name || "Unknown"}` 
      }
    });
  };

  return (
    <span
      onClick={handleTicketClicked}
      style={{ cursor: "pointer" }}
      className="p-share-btn"
    >
      <FontAwesomeIcon icon={faTicketAlt} className="mwh-15" style={{ marginRight: "5px" }} /> Convert to Ticket
    </span>
  );
};
